import { Box, SxProps, Theme } from '@mui/material';
import Image from 'next/image';

import { useFooter } from 'queries/global/useFooter';

import LinkUnstyled from 'components/@common/LinkUnstyled';

interface Props {
  sx?: SxProps<Theme>;
  onClick?: () => void;
}

const AppStores = ({ sx, onClick }: Props) => {
  const { storeLinks } = useFooter();

  const playStoreUrl = storeLinks?.googlePlayUrl;
  const appleStoreUrl = storeLinks?.appleStoreUrl;

  return (
    <Box
      sx={[
        {
          display: 'flex',
          gap: 2,
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    >
      {!!playStoreUrl && (
        <Box
          component={LinkUnstyled}
          href={playStoreUrl}
          target="_blank"
          sx={{
            display: 'flex',
            cursor: 'pointer',
            WebkitUserSelect: 'none',
          }}
          onClick={onClick}
        >
          <Image
            src="/images/play-store.svg"
            width={134}
            height={40}
            alt="Play Store"
            unoptimized
          />
        </Box>
      )}
      {!!appleStoreUrl && (
        <Box
          component={LinkUnstyled}
          href={appleStoreUrl}
          target="_blank"
          sx={{
            display: 'flex',
            cursor: 'pointer',
            WebkitUserSelect: 'none',
          }}
          onClick={onClick}
        >
          <Image
            src="/images/app-store.svg"
            width={120}
            height={40}
            alt="App Store"
            unoptimized
          />
        </Box>
      )}
    </Box>
  );
};

export default AppStores;
